import React from 'react'
import styles from './FluIndices.module.scss'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import GeoProvider from '../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from './dataDisplayOptions'
import { startDate, endDate, displayDate } from './dates'
import Header from './Header'
import MiddleCharts from './MiddleChart'
import GenderAgeView from './Charts/GenderAgeView'
import { useLocation } from "react-router-dom";
import diseaseDisplayOptions from './diseaseDisplayOptions'
import BelowMapNotification from '../Dashboard/BelowMapNotification'
const AllergiesDashboard = () => {
  if(window.localStorage.getItem('disease')===null)
    {window.localStorage.setItem('disease',diseaseDisplayOptions[0].value)}
  var getRegionType = 'zip3'
  const location = useLocation()
  const hash = location.hash
  if (hash) {
    if (hash.length > 1 && hash === '#zip3') {
      getRegionType = 'zip3'
    }
  }

  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              locationName={"nat"}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={getRegionType}
            >
              <Header headerType="nat" headerNumber={1}  geo_id="nat"/>
              <DashboardMap 
                geo_type={'nat'}
                geo_parent={'nat'}
                zoomLocation={'nat'} />
                <BelowMapNotification message_type='WEEKLY'/>
              <MiddleCharts geo_type="nat" geo_id="nat" data_type="ALLERGIES" />
              <GenderAgeView 
                data_type="ALLERGIES" 
                geo_type={'nat'}
                geo_id={'nat'}  
                searchLocation={'nat'} 
                searchLocationText={'nat'}/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default AllergiesDashboard
